import * as Bluebird from "bluebird";
import cssService from "../services/css.service";
import userService from "../users/userService";
import CompanyLoader, { getOwnCompanyID } from "../services/companyService";
var friendsService = require("../services/friendsService");
var localize = require("../i18n/localizationConfig");
var controllerModule = require("../controllers/controllerModule");
var friendsController = function ($scope) {
    cssService.setClass("friendsView");
    $scope.requests = [];
    var contacts = [];
    var colleagues = [];
    var contactsLoading = true;
    var colleaguesLoading = true;
    $scope.contactsFilter = {
        name: ""
    };
    $scope.showColleagues = false;
    $scope.isBusiness = function () { return WHISPEER_BUSINESS; };
    $scope.setShowColleagues = function (val) {
        return $scope.showColleagues = !!val;
    };
    $scope.isLoading = function () {
        return WHISPEER_BUSINESS && $scope.showColleagues ? colleaguesLoading : contactsLoading;
    };
    $scope.getContacts = function () {
        return WHISPEER_BUSINESS && $scope.showColleagues ? colleagues : contacts;
    };
    $scope.removeFriend = function (user) {
        if (confirm(localize.getLocalizedString("magicbar.requests.confirmRemove", { user: user.name }))) {
            user.user.removeAsFriend();
        }
    };
    var loadColleagues = function () {
        if (!WHISPEER_BUSINESS) {
            return Bluebird.resolve();
        }
        return getOwnCompanyID()
            .then(function (companyID) { return CompanyLoader.get(companyID); })
            .then(function (company) {
            return userService.getMultipleFormatted(company.getUserIDs())
                .then(function (result) {
                colleagues = result;
                colleaguesLoading = false;
            });
        });
    };
    var loadContacts = function () {
        return userService.getMultipleFormatted(friendsService.getFriends())
            .then(function (result) {
            contacts = result;
            contactsLoading = false;
        });
    };
    var loadRequests = function () {
        return userService.getMultipleFormatted(friendsService.getRequests())
            .then(function (result) {
            $scope.requests = result;
        });
    };
    var load = function () {
        loadRequests();
        loadContacts()
            .then(function () { return loadColleagues(); });
    };
    friendsService.awaitLoading().then(function () {
        friendsService.listen(load);
        load();
    });
    $scope.acceptRequest = function (request) { return request.user.acceptFriendShip(); };
    $scope.ignoreRequest = function (request) { return request.user.ignoreFriendShip(); };
};
controllerModule.controller("ssn.friendsController", ["$scope", friendsController]);



//////////////////
// WEBPACK FOOTER
// ./js/controllers/friendsController.ts
// module id = null
// module chunks = 